export const optionTypes = {
  MONEY: "money",
  DATE: "date",
  PHONE: "phone",
  BOOLEAN: "boolean",
  STRING: "string",
  MONTH: "month",
  BUTTON: "button",
  TIME: "time",
  EMPLOYEE: "employee",
  EMAIL_LIST: "emailList"
};
